import { useContext, useEffect } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext';
import "./pages.css";

import { Modal } from 'bootstrap';

import ClosePageButtonComponent from '../../components/commons/ClosePageButtonComponent';
import DarkButtonComponent from '../../components/commons/DarkButtonComponent';
import LightButtonComponent from '../../components/commons/LightButtonComponent'

const Mobile_LogOutPopupComponent = () => {
    const { setLogOutPopup, setCurrentUser, mobileSocketRef } = useContext(GlobalMobileContext);

    useEffect(() => {
        const modalEl = document.getElementById("logOutModal");
        if (modalEl) {
            const modal = new Modal(modalEl);
            modal.show();
        }
    }, [])


    const handleCloseModal = (logOut) => {

        const modalEl = document.getElementById("logOutModal");

        if (modalEl) {
            const modalInstance = Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
                document.body.classList.remove('modal-open');
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
            }
        }

        if (logOut) {
            setCurrentUser(null);
            mobileSocketRef.current.disconnect();
        }

        setLogOutPopup(false)
    }

    return (

        <div className="modal fade" id="logOutModal" tabIndex="-2">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ backgroundColor: "#292148", color: "#FFFFFF" }}>
                    <div className="modal-header" style={{ borderColor: "transparent", justifyContent: "center", textAlign: "center", paddingBottom: 0  }}>
                        <h5 className="modal-title">Log Out</h5>
                        <ClosePageButtonComponent setClose={() => handleCloseModal(false)} style={{ top: "20px", right: "20px", fontSize: "20px", lineHeight: "10px" }} />
                    </div>
                    <div className="modal-body" style={{ justifyContent: "center", textAlign: "center", paddingBottom: 0  }}>
                        Do you want to log out?
                    </div>
                    <div className="modal-footer" style={{ borderColor: "transparent", paddingTop: "10px", justifyContent: "center" }}>
                        <DarkButtonComponent
                            style={{
                                width: "auto", height: "38px", backgroundColor: "transparent", fontSize: "18px", lineHeight: "20px", borderRadius: "4px",
                                border: "1px solid #33FFC8", marginTop: "5px", paddingLeft: "20px", paddingRight: "20px"
                            }}
                            onClick={() => handleCloseModal(false)}>
                            No
                        </DarkButtonComponent>
                        <LightButtonComponent
                            style={{ width: "auto", height: "38px", fontSize: "18px", lineHeight: "20px", borderRadius: "4px", marginTop: "5px", alignItems: "center",
                                paddingLeft: "20px", paddingRight: "20px"
                            }}
                            onClick={() => handleCloseModal(true)}>
                            Yes
                        </LightButtonComponent>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Mobile_LogOutPopupComponent;
